import React from 'react';
import { Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material';

interface AlertProps {
  message: string;
  severity: 'success' | 'error';
  open: boolean;
  onClose: () => void;
}

const Alerts: React.FC<AlertProps> = ({ message, severity, open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Define el punto de corte para móviles

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={isMobile ? { vertical: 'bottom', horizontal: 'center' } : { vertical: 'bottom', horizontal: 'left' }} // Cambia la posición según el dispositivo
      sx={isMobile ? { position: 'fixed', bottom: 90, left: '45%', transform: 'translateX(-50%)', zIndex: 1300, width: "90%" } : {}} // Estilo específico para móviles
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Alerts;
